import createIcon from '../../createIcon';

/**
 * @component @name Mosque
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA5SDE3QzE3LjI5IDkgMTcuNTcgOS4wNiAxNy44NCA5LjEzQzE3LjkzIDguOCAxOCA4LjQ2IDE4IDguMDlDMTggNi43OCAxNy4zNSA1LjU2IDE2LjI2IDQuODRMMTIgMkw3Ljc0IDQuODRDNi42NSA1LjU2IDYgNi43OCA2IDguMDlDNiA4LjQ2IDYuMDcgOC44IDYuMTYgOS4xM0M2LjQzIDkuMDYgNi43MSA5IDcgOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yNCA4QzI0IDYuOSAyMiA1IDIyIDVDMjIgNSAyMCA2LjkgMjAgOEMyMCA4Ljc0IDIwLjQgOS4zOCAyMSA5LjcyVjE0SDE5VjEyQzE5IDEwLjkgMTguMSAxMCAxNyAxMEg3QzUuOSAxMCA1IDEwLjkgNSAxMlYxNEgzVjkuNzJDMy42IDkuMzggNCA4Ljc0IDQgOEM0IDYuOSAyIDUgMiA1QzIgNSAwIDYuOSAwIDhDMCA4Ljc0IDAuNCA5LjM4IDEgOS43MlYyMkgxMFYxOEMxMCAxNi45IDEwLjkgMTYgMTIgMTZDMTMuMSAxNiAxNCAxNi45IDE0IDE4VjIySDIzVjkuNzJDMjMuNiA5LjM4IDI0IDguNzQgMjQgOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Mosque = createIcon('Mosque', [
  [
    'path',
    {
      d: 'M7 9H17C17.29 9 17.57 9.06 17.84 9.13C17.93 8.8 18 8.46 18 8.09C18 6.78 17.35 5.56 16.26 4.84L12 2L7.74 4.84C6.65 5.56 6 6.78 6 8.09C6 8.46 6.07 8.8 6.16 9.13C6.43 9.06 6.71 9 7 9Z',
      key: 'bdk5en',
    },
  ],
  [
    'path',
    {
      d: 'M24 8C24 6.9 22 5 22 5C22 5 20 6.9 20 8C20 8.74 20.4 9.38 21 9.72V14H19V12C19 10.9 18.1 10 17 10H7C5.9 10 5 10.9 5 12V14H3V9.72C3.6 9.38 4 8.74 4 8C4 6.9 2 5 2 5C2 5 0 6.9 0 8C0 8.74 0.4 9.38 1 9.72V22H10V18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18V22H23V9.72C23.6 9.38 24 8.74 24 8Z',
      key: '161uxv',
    },
  ],
]);

export default Mosque;
